import { InjectionToken } from '@angular/core';

/**
 * Interface for providing authentication tokens to the HTTP interceptor.
 * This breaks the circular dependency between the interceptor and auth service.
 */
export interface AuthTokenProvider {
  /**
   * Gets a valid access token, refreshing if necessary.
   * @returns The access token or a promise that resolves to the token
   */
  getAccessToken(): string | Promise<string>;

  /**
   * Checks if the current access token is valid.
   * @returns True if the token is valid, false otherwise
   */
  isAccessTokenValid(): boolean;

  /**
   * Gets the token endpoint URL.
   * @returns The token endpoint URL or undefined if not available
   */
  getTokenEndpoint(): string | undefined;
}

/**
 * Injection token for the AuthTokenProvider.
 * Used to provide token access functionality to the HTTP interceptor
 * without creating circular dependencies.
 */
export const AUTH_TOKEN_PROVIDER = new InjectionToken<AuthTokenProvider>(
  'AUTH_TOKEN_PROVIDER',
);
